<footer>
	{{ getCurrentYear() }} &copy; {{ 'footer.projectName' | translate }} <a target="_blank"
		href="https://primefin.tech">{{ 'footer.companyName' | translate }}</a>
</footer>